export const updateDescription = (paragraph, currency, price) => {
    if (paragraph?.includes("SAR 107") && currency && price) {
        return paragraph?.replace(/SAR 107/g, `${currency} ${price}`);
    }
    return paragraph;
};
